import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

const Series = ()=> import('../views/Series')
const SeriesDetail = ()=> import('../views/SeriesDetail')

const Story = ()=> import('../views/Story')
const StoryDetail = ()=> import('../views/StoryDetail')

const ProductDetail = ()=> import('../views/Product')

const WhereToBuy = ()=> import('../views/WhereToBuy')

const Contact = ()=> import('../views/Contact')
const FAQ = ()=> import('../views/FAQ')
const FAQDetail = ()=> import('../views/FAQDetail')
const LawClause = ()=> import('../views/LawClause')
const Terms = ()=> import('../views/Terms')
const SaleService = ()=> import('../views/SaleService')

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: '首页',
        component: Home,
    },
    {
        path: '/collections',
        name: '全部系列',
        component: Series,
    },
    {
        path: '/fine_jewelry',
        name: '高级珠宝',
        component: Series,
    },
    {
        path: '/fashion_jewelry',
        name: '时尚珠宝',
        component: Series,
    },
    {
        path: '/collections/:id',
        name: '系列详情',
        component: SeriesDetail,
    },
    {
        path: '/stories',
        name: '品牌故事',
        component: Story,
    },
    {
        path: '/stories/:id',
        name: '品牌故事详情',
        component: StoryDetail,
    },
    {
        path: '/product/:id',
        name: '产品详情',
        component: ProductDetail,
    },
    {
        path: '/purchase',
        name: '购买方式',
        component: WhereToBuy,
    },
    {
        path: '/contact',
        name: '联系我们',
        component: Contact,
    },
    {
        path: '/faq',
        name: '常见问题',
        component: FAQ,
    },
    {
        path: '/faq/:id',
        name: '常见问题',
        component: FAQDetail,
    },
    {
        path: '/terms',
        name: '适用条款',
        component: Terms,
    },
    {
        path: '/law-clause',
        name: '政策条款',
        component: LawClause,
    },
    {
        path: '/service',
        name: '售后服务',
        component: SaleService,
    },
    {
        path: '/template',
        name: '模版',
        component: () => import(/* webpackChunkName: "template" */ '../views/Template.vue'),
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
